import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import utils from '../../utils'
import { useParams } from 'react-router-dom';
import Loading from '../../components/feedback/Loading';
import FetchError from '../../components/feedback/FetchError';
import adminServices from '../../services/AdminServices';
import { MdEdit } from 'react-icons/md';
import moment from 'moment';
import PatientModal from '../../components/patients/PatientModal';
import NurseSidebar from '../../components/nurses/NurseSidebar';
import NurseDetails from '../../components/nurses/NurseDetails';
import NurseRecords from '../../components/nurses/NurseRecords';
import NurseFinances from '../../components/nurses/NurseFinances';

function PatientViewPage() {
    const { id } = useParams();
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const [patient, setPatient] = useState()
    const [currentTab, setCurrentTab] = useState(0)
    const [activeUser, setActiveUser] = useState(null);

    const getPatient = (id) => {
        adminServices.getPatient(id).then(
            res => {
                setPatient(res.data)
                setLoading(false)
            },
            err => {
                console.log(err);
                setError(err)
                setLoading(false)
            }
        )
    }

    useEffect(() => {
        if (id) {
            getPatient(id)
        }
    }, [id])

    function openModal(user) {
        const openBtn = document.getElementById("patient-create-open-btn");
        setActiveUser(user);
        if (openBtn) openBtn.click();
    }
    function fetchPatient() {
        getPatient(patient?.id)
    }
    return (
        <div>
            <Helmet>
                <title>Patient View - {utils.siteName}</title>
            </Helmet>
            <PatientModal
                onReload={fetchPatient}
                setActiveUser={setActiveUser}
                action={1}
                activeUser={activeUser}
            />
            <div className="container mx-auto">
                {loading && (
                    <div className="p-3">
                        <Loading />
                    </div>
                )}
                {error && (
                    <div className="p-3">
                        <FetchError error={error} />
                    </div>
                )}
                {patient && (
                    <div className="space-y-6">
                        <div className='flex flex-col md:flex-row gap-4 md:justify-between md:items-center'>
                            <div className="flex items-center gap-4 group">
                                {patient.user?.image ? (
                                    <img
                                        src={patient.user?.image}
                                        alt={patient.user?.full_name}
                                        className="w-20 h-20 rounded-full mr-2 object-cover"
                                    />
                                ) : (
                                    <div className="w-20 h-20 rounded-full bg-neutral text-white flex items-center justify-center mr-2 text-xl font-bold hover:underline">
                                        {patient.user?.full_name?.charAt(0)}
                                    </div>
                                )}
                                <div className="">
                                    <span className='font-bold text-2xl'>{patient.user?.full_name}</span>
                                    <div className="flex flex-col md:flex-row gap-4">
                                        <p className='font-mono'>
                                            {patient?.user?.phone_number ? (
                                                <span>{patient?.user?.phone_number}</span>
                                            ) : (
                                                <span>{patient?.user?.email}</span>
                                            )}
                                        </p>
                                        <p>Joined: {moment(patient?.creation_time).format("MMMM Do YYYY")}</p>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <button
                                    onClick={() => {
                                        openModal(patient)
                                    }}
                                    className='btn btn-primary'><MdEdit /> Edit Patient</button>
                            </div>
                        </div>

                        <div className='flex flex-col md:flex-row gap-4'>
                            <div className='md:w-3/12'>
                                <NurseSidebar
                                    currentTab={currentTab}
                                    setCurrentTab={setCurrentTab}
                                />
                            </div>
                            <div className='md:w-9/12'>
                                {currentTab === 0 && (
                                    <NurseDetails
                                        key={patient}
                                        userObject={patient} />
                                )}

                                {currentTab === 1 && (
                                    <NurseRecords
                                        userObject={patient} />
                                )}

                                {currentTab === 2 && (
                                    <NurseFinances
                                        userObject={patient} />
                                )}
                            </div>
                        </div>

                    </div>
                )}
            </div>

        </div>
    )
}

export default PatientViewPage